type AlertProps =
  | { showArchived: true }
  | { showExpired: true }
  | { showExpireSoon: true; segmentDaysRemaining: number }
  | null;

export const getSegmentAlertProps = (
  showArchived: boolean,
  showExpired: boolean,
  showSoon: boolean,
  daysRemaining?: number
): AlertProps => {
  if (showArchived) {
    return { showArchived: true };
  }

  if (showExpired) {
    return { showExpired: true };
  }

  if (showSoon && typeof daysRemaining === 'number') {
    return { showExpireSoon: true, segmentDaysRemaining: daysRemaining };
  }

  return null;
};
